import { render, staticRenderFns } from "./UpdateEmailOverlay.vue?vue&type=template&id=5f21a3cd&scoped=true"
import script from "./UpdateEmailOverlay.vue?vue&type=script&lang=js"
export * from "./UpdateEmailOverlay.vue?vue&type=script&lang=js"
import style0 from "./UpdateEmailOverlay.vue?vue&type=style&index=0&id=5f21a3cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f21a3cd",
  null
  
)

export default component.exports